<template>

    <!-- Блок з відображенням причин критичності -->
    <b-card v-if="form.reason && form.priority === 3">
        <h5 class="fw-semibold text-uppercase mb-3 border-bottom pb-2">{{ $t('ReasonsforCriticality') }}</h5>
        <div class="ql-container">
            <div class="ql-editor" v-html="form.reason">
            </div>
        </div>
    </b-card>

    <!-- Блок з описом тікету -->
    <b-card>
        <h5 class="fw-semibold text-uppercase mb-3 border-bottom pb-2">{{ $t('descTicket') }}</h5>
        <div class="ql-container">
            <div class="ql-editor" v-html="form.createComment">
            </div>
        </div>
    </b-card>

    <b-row>

        <!-- Коментар закриття тікету від автора -->
        <b-col lg="6" v-if="form.closeComment != null">
            <div class="card card-animate">
                <div class="card-body">
                    <div class="d-flex align-items-center border-bottom pb-2">
                        <div class="flex-grow-1">
                            <p class="text-uppercase fw-medium text-muted mb-0">{{ $t('ticketClose') }}</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                <p>{{form.closeComment}}</p>
                            </h4>
                            <a class="text-muted">{{ form.closeDatetime }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </b-col>

        <!-- Коментар перевідкриття тікету від автора -->
        <b-col lg="6" v-if="form.reopenComment != null">
            <div class="card card-animate">
                <div class="card-body">
                    <div class="d-flex align-items-center border-bottom pb-2">
                        <div class="flex-grow-1">
                            <p class="text-uppercase fw-medium text-muted mb-0">{{ $t('reopenTicket') }}</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                <p>{{form.reopenComment}}</p>
                            </h4>
                            <a class="text-muted">{{ form.reopenDatetime }}</a>

                            <!-- Хто останній перевідкрив тікет -->
                            <div class="mt-3" v-if="form.whoReopenLast">
                                <p class="text-uppercase fw-medium text-muted mb-1 fs-11">{{ $t('whoReopened') }}</p>
                                <span class="badge bg-danger-subtle text-danger fs-12">
                                    <i class="ri-user-line align-bottom me-1"></i>{{ form.whoReopenLast.workerName }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-col>

        <!-- Блок з рішенням тікету -->
        <b-col lg="6" v-if="form.decidedComment != null">
            
            <div class="card card-animate">
                <div class="card-body">
                    <div class="d-flex align-items-center border-bottom pb-2">
                        <div class="flex-grow-1">
                            <p class="text-uppercase fw-medium text-muted mb-0">{{ $t('Decision') }}</p>
                        </div>
                        <div class="flex-shrink-0">
                            
                            <!-- Статус рішення тікету (в релізі, чекає на реліз та інше) -->
                            <h5 :class="`fs-12 mb-0 ${this.mutateStatus(form.decidedStatus).color}`">
                                {{ this.mutateStatus(form.decidedStatus).name }}
                            </h5>

                            <!-- Переглянути інші дані по рішенню -->
                            <!-- <button 
                                type="button" 
                                style="margin-left: 10px;"
                                class="btn btn-info btn-icon btn-sm fs-16 close-btn-email"
                            >
                                <i class="ri-eye-fill align-bottom"></i>
                            </button> -->
                        </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <!-- Коментар рішення до тікету від розробника -->
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                                <p>{{form.decidedComment}}</p>
                            </h4>
                            <!-- <a class="text-muted">{{ form.decidedDatetime }}</a>
                            <a class="text-muted">{{ getDeadline(form) }}</a> -->
                        </div>
                    </div>
                    <div class="d-flex align-items-center pb-2" >

                        <!-- Дата та час додавання рішення -->
                        <div class="flex-grow-1">
                            <p class="text-uppercase fw-medium text-muted mb-0">
                                {{form.decidedDatetime}}
                            </p>
                        </div>
                        
                        <!-- Дедлайн -->
                        <div class="flex-shrink-0">
                            <h5
                                class="fs-12 mb-0 badge bg-info"
                                v-if="form.deadlineId"
                            >
                                {{ $t('dateRelease') }} : {{ getDeadline(form) }}
                            </h5>
                        </div>
                    </div>

                    <!-- Хто зараз тестує тікет (поки статус рішення - "Тестується") -->
                    <div class="pb-2" v-if="form.decidedStatus == 'intesting' && form.whoStartedTest">
                        <p class="text-uppercase fw-medium text-muted mb-1 fs-11">{{ $t('whoTestingNow') }}</p>
                        <span class="badge bg-info-subtle text-info fs-12">
                            <i class="ri-user-line align-bottom me-1"></i>{{ form.whoStartedTest.workerName }}
                        </span>
                    </div>

                    <!-- Хто останній підтвердив тестування -->
                    <div class="pb-2" v-if="form.whoPassedTestLast">
                        <p class="text-uppercase fw-medium text-muted mb-1 fs-11">{{ $t('WhoConductedtheTesting') }}</p>
                        <span class="badge bg-success-subtle text-success fs-12">
                            <i class="ri-user-line align-bottom me-1"></i>{{ form.whoPassedTestLast.workerName }}
                        </span>
                    </div>

                    <!-- <div class="d-flex mt-3" v-if="form.status != 'closed'"> -->
                    <div class="d-flex mt-3" >

                        <!-- 
                            Кнопка "Деталі рішення"
                        -->
                        <button
                            type="button"
                            :class="`btn btn-soft-primary detail-eye-btn ${checkWidthDetail() ? '' : 'w-100'} `"
                            style="margin-top: 10px;margin-right: 5px;"
                            v-if="checkShowDetail() || perms[2000]"
                            @click="showDetailBox = true"
                        >
                        <!-- v-if="checkShowDetail()" -->
                            <i class="ri-eye-fill align-bottom"></i> <span v-if="!checkWidthDetail()" style="margin-left: 3px;">Деталі рішення</span>
                        </button>

                        <!-- 
                            Кнопка "Змінити статус рішення"/випустити в реліз
                        -->
                        <button 
                            v-if="form.decidedStatus == 'waitrelease' || perms[2000]"
                            type="button" 
                            :class="`btn btn-soft-success ${checkWidthDetail() ? '' : 'w-100'} `" 
                            style="margin-top: 10px;margin-right: 5px;"
                            @click="showConfirmChangeDecided = true"
                        >
                            <i class="ri-share-forward-line align-bottom"></i> 
                            <span v-if="!checkWidthDetail()" style="margin-left: 3px;">У реліз</span>
                        </button>

                        <!--
                            Кнопка "Почати тестування"
                            - показується тільки при статусі "очікує тестування" (waittesting)
                            - переводить тікет у стан "тестується" (intesting)
                        -->
                        <button
                            type="button"
                            class="btn btn-soft-info w-100"
                            style="margin-top: 10px;margin-right: 5px;"
                            @click="startTesting()"
                            v-if="this.form.decidedStatus == 'waittesting'"
                        >
                            {{ this.$t('startTesting') }}
                        </button>

                        <!--
                            Кнопка "Підтвердити тестування"
                            - доступна будь-якому співробітнику — тестувати тікет може будь-хто, тож і підтверджувати тестування може будь-хто
                            - йде перевірка на статус тікету
                            - - статус має бути "тестується" (спочатку тікет треба перевести в цей стан кнопкою "Почати тестування")
                        -->
                        <button
                            type="button"
                            class="btn btn-success w-100"
                            style="margin-top: 10px;margin-right: 5px;"
                            @click="inRelease()"
                            v-if="this.form.decidedStatus == 'intesting' && form.status != 'closed'"
                        >
                            {{ this.$t('Confirm') }}
                        </button>

                        <!--
                            Кнопка "Закрити тікет"
                            - йде перевірка на права доступу 301 (додати тікет) та 2000(режим бога)
                            - йде перевірка на автора тікету АБО роль тестувальника (workerJob == 'tester') — тестувальник може закривати чужі тікети (тікет #7404)
                            - йде перевірка на статус тікету
                            - - статус має бути "в релізі"
                        -->
                        <button
                            type="button"
                            class="btn btn-success w-100"
                            style="margin-top: 10px;margin-right: 5px;"
                            @click="showClose()"
                            v-if="(perms[2000] == true || form.createWorkerId == this.user.userid || this.user.workerJob == 'tester') && (this.form.decidedStatus == 'inrelease' || this.form.decidedStatus == 'in_release' || this.form.decidedStatus == 'noProblem') && form.status != 'closed'"
                        >
                            {{ this.$t('closeTicket') }}
                        </button>

                        <!--
                            Кнопка "Перевідкрити тікет"
                            - показується при статусах "тестується" / "чекає на реліз" / "в релізі" / "немає проблеми" — перевідкрити може будь-хто (без перевірки автора чи прав 2000)
                            - "очікує тестування" прибрано: з цього статусу спочатку треба почати тестування
                        -->
                        <button
                            type="button"
                            class="btn btn-danger w-100"
                            style="margin-top: 10px;"
                            @click="showReopen()"
                            v-if="this.form.decidedStatus == 'intesting' || this.form.decidedStatus == 'waitrelease' || this.form.decidedStatus == 'inrelease' || this.form.decidedStatus == 'in_release' || this.form.decidedStatus == 'noProblem'"
                        >
                            {{ this.$t('ReopenTicket') }}
                        </button>

                    </div>
                </div>
            </div>
        </b-col>
    </b-row>

    <!-- Вікно з деталями рішення по тікету -->
    <boxDetailDecision 
        v-if="showDetailBox"
        @close="showDetailBox = false"
        :objCard="obj"
    />

    <!-- Вікно з підтвердженням зміни статусу рішення тікету на in_release -->
    <confirmChangeDecidedStatus 
        v-if="showConfirmChangeDecided"
        @close="showConfirmChangeDecided = false"
        @confirmDecidedTicket="changeDecidedStatus"
    />

</template>

<script>
import boxDetailDecision from './boxDetailDecision.vue';
import confirmChangeDecidedStatus from './confirmChangeDecidedStatus.vue';
import { mutateDecidedStatusTicket } from '@/usabilityScripts/globalMutate.js'
import { Tickets } from '@/API.js';
import { storeS } from '@/store'

let apiTickets = new Tickets();

export default{
    props: ['obj'],
    components: {
        boxDetailDecision,
        confirmChangeDecidedStatus
    },
    data(){
        return{
            form:'',
            showDetailBox: false,
            showConfirmChangeDecided: false,
        }
    },
    created(){
        this.replaceCreateComment()
        this.getdata();
    },
    mounted() {
        // for(let i = 0; i<document.querySelector('.ql-editor').querySelectorAll('img').length; i++) {
        //     document.querySelector('.ql-editor').querySelectorAll('img')[i].addEventListener('click', () => {
        //         this.eventBus.emit('fullImageSize', {
        //             url: document.querySelector('.ql-editor').querySelectorAll('img')[i].getAttribute("src") + ''
        //         })

                //  don`t uncomment 

                // document.querySelector('.ql-editor').querySelectorAll('img')[i].getAttribute("src")
                // let newDiv = document.createElement('div')
                // newDiv.className = 'fullSizeImage'
                // newDiv.style.top = '5vh'
                // newDiv.style.left = '5vw'
                // newDiv.style.zIndex = '99999'
                // newDiv.style.position = 'absolute'
                // newDiv.style.backgroundImage = `url(${document.querySelector('.ql-editor').querySelectorAll('img')[i].getAttribute("src")})`
                // newDiv.style.backgroundRepeat = 'no-repeat'
                // let height = document.querySelector('.ql-editor').querySelectorAll('img')[i].offsetHeight * 3
                // let width = document.querySelector('.ql-editor').querySelectorAll('img')[i].offsetWidth * 3
                // console.log(height, width)
                // newDiv.style['height'] = `${height}`
                // newDiv.style['width'] = `${width}`
                // newDiv.style.backgroundColor = 'black'
                // let currentDiv = document.querySelector('#app')
                // document.body.insertBefore(newDiv, currentDiv)

                //  don`t uncomment 

        //     })
        // }
    },
    methods: {
        changeDecidedStatus(){
            // Зміна статусу рішення тікету 

            var bodyRequest = {
                decidedStatus: "in_release"
            }

            apiTickets.changeDecidedStatus(this.obj.ticketId, bodyRequest).then(result => {
                if(result.status == 'done') {
                    this.eventBus.emit("updateTicket", true);
                } else {
                    this.$toast.error('error')
                }
            })

        },
        canStartTesting() {
            // Почати тестування може той, хто взяв тікет у роботу (inJobWorkers),
            // або режим бога (perms[2000])
            return this.perms[2000] == true
                || (Array.isArray(this.obj.inJobWorkers)
                    && this.obj.inJobWorkers.some(el => el.workerId == this.user.userid));
        },
        startTesting(){
            // Почати тестування тікету (waittesting -> intesting)

            if (!this.canStartTesting()) {
                this.$toast.error(this.$t('takeTicketToWorkFirst'));
                return;
            }

            apiTickets.startTestingTicket(this.obj.ticketId).then(result => {
                if(result.status == 'done') {
                    this.eventBus.emit("updateTicket", true);
                } else {
                    this.$toast.error('error')
                }
            })
        },
        replaceCreateComment() {
            const parser = new DOMParser();
            const doc = parser.parseFromString(this.obj.createComment, "text/html");

            // Знаходимо всі теги <p> у документі
            const paragraphs = doc.querySelectorAll("p");

            paragraphs.forEach((p) => {
                // Знаходимо всі <img> всередині <p>
                const images = p.querySelectorAll("img");

                images.forEach((img) => {
                    // Створюємо новий <p> для <img>
                    const newParagraph = document.createElement("p");
                    newParagraph.appendChild(img.cloneNode(true));

                    // Вставляємо новий <p> після поточного <p>
                    p.parentNode.insertBefore(newParagraph, p.nextSibling);

                    // Видаляємо <img> з початкового <p>
                    img.remove();
                });
            });

            // Перетворюємо назад в HTML-рядок
            const resultHTML = doc.body.innerHTML;
            this.obj.createComment = resultHTML
        },
        inRelease() {
            this.$emit('inRelease', this.form.ticketId)
        },
        showReopen() {
            this.$emit('showReopen', this.form.ticketId)
        },
        showClose(){
            this.$emit('showClose', this.form.ticketId)
        },
        getdata(){
            this.form = this.obj
        },
        mutateStatus(e){
            return mutateDecidedStatusTicket(e)
        },
        getDeadline(e){
            const deadline = this.deadlines.find(el => el.deadlineId === e.deadlineId);

            if (deadline) {
                // Видаляємо час, залишаємо лише дату
                const dateOnly = deadline.deadlineDate.split(' ')[0];
                console.log("deadlineDate", dateOnly);
                return dateOnly;
            } else {
                console.log("deadlineDate", "-");
                return "-";
            }
        },
        checkShowDetail(){
            if(
                this.form.problemIn == '' 
                && this.form.sinceProblemKnown == ''
                && this.form.solutionReason == ''
                && this.form.problemWas == false
                && this.form.passedTest == false
                && this.form.type == "problem"
            ) {
                return false
            } else {
                return true
            }
        },
        checkWidthDetail(){
            if(
                (this.perms[2000] == true || this.form.createWorkerId == this.user.userid)
                && (this.form.decidedStatus == 'inrelease' || this.form.decidedStatus == 'in_release' || this.form.decidedStatus == 'noProblem' || this.form.decidedStatus == 'waittesting' || this.form.decidedStatus == 'intesting')
            ) {
                return true
            } else {
                return false
            }
        }
    },
    computed: {
        deadlines(){
            return storeS.dealines
        },
        user(){
            return storeS.userbase
        },
        perms(){
            return storeS.perms
        }
    }
}
</script>

<style scoped>
/* Робимо іконку ока ("Деталі рішення") добре видимою в темній темі */
[data-layout-mode="dark"] .detail-eye-btn {
    background-color: rgba(64, 81, 137, 0.35);
    color: #a3bffa;
}
[data-layout-mode="dark"] .detail-eye-btn i {
    color: #cdd9ff;
}
[data-layout-mode="dark"] .detail-eye-btn:hover {
    background-color: #4051a3;
    color: #ffffff;
}
[data-layout-mode="dark"] .detail-eye-btn:hover i {
    color: #ffffff;
}
</style>